/* Publish by EComposer at 2026-10-02 08:59:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-asjmskz3lpi"]=  window.__ectimmers["ecom-asjmskz3lpi"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-asjmskz3lpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asjmskz3lpi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mztad2y0nir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mztad2y0nir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p325hz3wxkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p325hz3wxkl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5fprfn7u6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5fprfn7u6k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3peo1ca31ah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3peo1ca31ah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1l9t3jmk4tw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1l9t3jmk4tw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ouh4yn9fpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ouh4yn9fpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-camobcindyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-camobcindyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf33c9f818').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf33c9f818', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qqoiabzm59q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qqoiabzm59q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d89r8kbube').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d89r8kbube', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wvrmhwy36q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wvrmhwy36q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsybkcvngjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsybkcvngjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-178pqs8tnpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-178pqs8tnpn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hyi3vprryv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hyi3vprryv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0vb8vpmufb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0vb8vpmufb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74grs8y3ft').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74grs8y3ft', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-no9icg8cr4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-no9icg8cr4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40u7au0hzb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40u7au0hzb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0u8ssphw8zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0u8ssphw8zr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ays14xrjr4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ays14xrjr4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ljyw3ubwba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ljyw3ubwba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-boop43gkftc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-boop43gkftc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8q12o45uqar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8q12o45uqar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p4pli62pcuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4pli62pcuf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ro4thlb1wtn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ro4thlb1wtn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3coxybl8n3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3coxybl8n3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dkz74m4ech').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dkz74m4ech', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tb36831fwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tb36831fwg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1pnf6qzbej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1pnf6qzbej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0ceqx3lyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0ceqx3lyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ef2igxz9yb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ef2igxz9yb8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ylaidc8e2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ylaidc8e2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kl5jklccpkr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kl5jklccpkr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztbonyu8sl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztbonyu8sl9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6pzf12hoyhx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6pzf12hoyhx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cicje2rjvf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cicje2rjvf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2z9ikru6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2z9ikru6l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30xs54lsfdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30xs54lsfdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5l0nhinu4rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5l0nhinu4rg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wntc0jofs5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wntc0jofs5h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92b6aumn3lu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92b6aumn3lu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-buhnf6thmbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-buhnf6thmbd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hvg0cd9sxhs"]=  window.__ectimmers["ecom-hvg0cd9sxhs"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-hvg0cd9sxhs"]["3gsakhyay"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-hvg0cd9sxhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hvg0cd9sxhs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aaa7vxu8yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aaa7vxu8yl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9jzbe3684i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9jzbe3684i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-br8bfq7o1fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-br8bfq7o1fk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wgupn18xios').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgupn18xios', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ny462jcb38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ny462jcb38', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1sweoodqfd6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1sweoodqfd6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t117jx4uty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t117jx4uty', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ix3ywlwm7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ix3ywlwm7k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4rmazzc4cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4rmazzc4cj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzps0zxaqsi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzps0zxaqsi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-slz1j96qqpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-slz1j96qqpp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5wslq2nmkih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5wslq2nmkih', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djjpw37g32n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djjpw37g32n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1blmhkpwnga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1blmhkpwnga', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-97m60t4bfa9"]=  window.__ectimmers["ecom-97m60t4bfa9"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-97m60t4bfa9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97m60t4bfa9', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-322asacrmzo"]=  window.__ectimmers["ecom-322asacrmzo"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-322asacrmzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-322asacrmzo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tdao2p821').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tdao2p821', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gllchyfjaz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gllchyfjaz9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mg7zkhibe6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mg7zkhibe6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j367x8gyl1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j367x8gyl1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-187g89bxlbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-187g89bxlbx', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31npheja0vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31npheja0vb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vedyk1i79p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vedyk1i79p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9bgjmdu6s34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9bgjmdu6s34', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwh8k07gbz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwh8k07gbz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ev6re4c6oh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ev6re4c6oh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0s3ar8ii2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0s3ar8ii2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85qbn1iblxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85qbn1iblxq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}